export const yellow = "#fdd34e";
export const blue = "#1FA09D";
export const lightBrown = "#F2EAD3";
export const orange = "#fcba36";
export const grey = "#767171";
